import React, { useContext, useEffect, useState } from "react";
import "../../assets/css/--page-aboutus.css";
import ourValuesText from "../../assets/images/our-legacy-and-values.png";
import interior from "../../assets/images/interior.png";
import familyOwnedIcon from "../../assets/images/family-owned-icon.png";
import welcomingSpaceIcon from "../../assets/images/welcoming-space-icon.png";
import qualityMealsIcon from "../../assets/images/quality-meal-icon.png";
import friendlyStaffIcon from "../../assets/images/friendly-staff-icon.png";
import exploreImg from "../../assets/images/explore-image.jpg";
import { ValueCard } from "./valueCard";
import exploreMainText from "../../assets/images/explore-mains-text.png";
import { useNavigate } from "react-router-dom";

export default function ExploreSection() {
  const history = useNavigate();
  return (
    <div className="explore-section">
      <div className="wrapper">
        <div className="explore-layout">
          <div className="content-section">
            <img src={exploreMainText} alt="Explore" />
            <h1>Come Visit — We’re Open 7 Days a Week!</h1>
            <p>
              Whether you're starting your day with a hot breakfast, swinging by for a quick lunch, or grabbing dinner and essentials on
              your way home — Main’s is here for you. With friendly faces, comforting food, and shelves stocked with the everyday items you
              need, we’re more than just a stop — we’re part of your routine.
            </p>
            <div className="explore-buttons">
              <a
                href="https://share.google/9lqJRYSi6i52639Km"
                className="btn btn-primary find-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#FFFFFF" width={20} height={20}>
                  <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z"></path>
                </svg>
                FIND MAIN'S
              </a>
              <button onClick={() => history("/menu")} className="btn btn-secondary">
                VIEW OUR MENU
              </button>
            </div>
          </div>
          <img className="explore-img" src={exploreImg} alt="Explore" />
        </div>
      </div>
    </div>
  );
}
